/* unplugin-vue-components disabled */import { render } from "./science_boot_m.vue?vue&type=template&id=17611345&scoped=true"
import script from "./science_boot_m.vue?vue&type=script&lang=js"
export * from "./science_boot_m.vue?vue&type=script&lang=js"

import "./science_boot_m.vue?vue&type=style&index=0&id=17611345&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17611345"]])

export default __exports__